import Checkboxes from 'components/Formik/Checkboxes';

const DiagnosedConditions = ({ initialValues, data }) => {
	initialValues.valveDiseaseDiagnosed = [];
	const { label, options } = data;
	return (
		<div>
			<p>
				<strong>{label}</strong>
			</p>
			<div className='grid-md-12'>
				<div className='col-md-7'>
					<Checkboxes
						options={options}
						label='valveDiseaseDiagnosed'
						name='valveDiseaseDiagnosed'
						split
					/>
				</div>
			</div>
		</div>
	);
};

export default DiagnosedConditions;
